// src/components/okaimonoAPI.js

const callbackRegistry = {};
let callbackCounter = 0;

export function callOkaimonoAPI(method, args = {}) {
	const callbackId = "cb_" + Date.now() + "_" + (++callbackCounter);

	const request = { method, callbackId, args };
	console.log("-----------------");
	console.log(`>> ${method} 呼び出し:\n`, request);

	const ua = navigator.userAgent.toLowerCase();
	const isIOS = /iphone|ipad|ipod/.test(ua);
	const isAndroid = ua.includes("android");

	return new Promise((resolve, reject) => {
		callbackRegistry[callbackId] = { resolve, reject };

		if (isIOS && window.webkit?.messageHandlers?.callOkaimonoApp?.postMessage && !window._isDummyIOS) {
			console.log(">> ネイティブAPI接続: iOS");
			window.webkit.messageHandlers.callOkaimonoApp.postMessage(JSON.stringify(request));
		} else if (isAndroid && window.OkaimonoApp?.callOkaimonoApp && !window._isDummyAndroid) {
			console.log(">> ネイティブAPI接続: Android");
			window.OkaimonoApp.callOkaimonoApp(JSON.stringify(request));
		} else {
			console.log(">> ネイティブAPI未接続: ダミーアプリ応答");
			mockOkaimonoCall(method, callbackId, args);
		}
	});
}

export function onResult(rawResponse) {
	console.log(">> onResult 受信:");

	try {
		const response = typeof rawResponse === "string" ? JSON.parse(rawResponse) : rawResponse;
		const { callbackId } = response;

		let result = response.result;

		// ✅ result.value が string の場合のみ JSON.parse
		if (typeof result === "object" && typeof result.value === "string") {
			try {
				// result.value = JSON.parse(result.value);
				result.value = result.value;
			} catch (e) {
				console.warn("value の JSON.parse に失敗しました:", e);
			}
		}

		const cb = callbackRegistry[callbackId];
		if (cb) {
			cb.resolve({ callbackId, result });
			delete callbackRegistry[callbackId];
		} else {
			console.warn("未登録のcallbackId:", callbackId);
		}
	} catch (e) {
		console.log(">> JSONデコードエラー");
		console.log("raw response:", rawResponse);
	}
}

function mockOkaimonoCall(method, callbackId, args) {
	setTimeout(() => {
		let result;
		switch (method) {
			case 'getDeviceLocation':
				result = {
					callbackId,
					result: {
						result: "1",
						longitude: 140.113616,
						latitude: 35.600458
					}
				};
				break;
			case 'didScreenTransition':
			case 'updateCartInformation':
			case 'closeRegigoApp':
			case 'didCompletedPayment':
			case 'didScanInformation':
			case 'didTapExternalBrowserUrl':
			case 'tapCouponBarcode':
			case 'saveTransactionData':
				result = {
					callbackId,
					result: {
						result: "1"
					}
				};
				break;
			case 'getOsVersion':
				result = {
					callbackId,
					result: {
						result: "1",
						os: 0,
						version: "13.0.0"
					}
				};
				break;
			case 'getAppVersion':
				result = {
					callbackId,
					result: {
						result: "1",
						appVersion: "12.5.0"
					}
				};
				break;
			case 'checkSilentMode':
				result = {
					callbackId,
					result: {
						result: "1",
						status: "0"
					}
				};
				break;
			case 'loadTransactionData': // ✅ 修正ポイント：value をオブジェクトとして返す
				if(args.key === 'tcode'){
					result = {
						callbackId,
						result: {
							result: "1",
							value: "BROWSER0123456789"
						}
					};
				}else{
					result = {
						callbackId,
						result: {
							result: "1",
							value: "81754_0000052160_2025-07-24"
						}
					};
				}
				break;
			default:
				result = {
					callbackId,
					result: {
						result: "0",
						error: {
							code: 101,
							message: "未対応のメソッドです"
						}
					}
				};
		}
		onResult(result);
	}, 500);
}

if (typeof window !== "undefined") {
	window.onResult = onResult;
}
